import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import DashboardShell from "@/components/DashboardShell";
import ReportView from "@/components/ReportView";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, Users2, UserCog, ScrollText, PlayCircle, Mail, FileBadge, RefreshCw, BarChart3, BookOpen, Layers } from "lucide-react";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, testId: "nav-admin-dashboard" },
  { to: "/admin/executives", label: "Marketing Executives", icon: UserCog, testId: "nav-admin-executives" },
  { to: "/admin/students", label: "Students", icon: Users2, testId: "nav-admin-students" },
  { to: "/admin/inbox", label: "Inbox", icon: Mail, testId: "nav-admin-inbox" },
  { to: "/admin/audit", label: "Audit Log", icon: ScrollText, testId: "nav-admin-audit" },
  { to: "/admin/sample-report", label: "Sample Report", icon: FileBadge, testId: "nav-admin-sample-report" },
  { to: "/admin/analytics", label: "Analytics", icon: BarChart3, testId: "nav-admin-analytics" },
  { to: "/admin/how-it-works", label: "How It Works", icon: BookOpen, testId: "nav-admin-how-it-works" },
  { to: "/admin/questions", label: "Question Bank", icon: Layers, testId: "nav-admin-questions" },
  { to: "/me/demo", label: "Demo Mode", icon: PlayCircle, testId: "nav-admin-demo" },
];

export default function AdminSampleReport() {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [regenerating, setRegenerating] = useState(false);

  const fetchReport = () => {
    setLoading(true);
    api.get("/admin/sample-report")
      .then((res) => setReport(res.data))
      .catch(() => setReport(null))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchReport(); }, []);

  const regenerate = async () => {
    setRegenerating(true);
    await api.post("/admin/sample-report/regenerate");
    const poll = setInterval(async () => {
      const res = await api.get("/admin/sample-report").catch(() => null);
      if (res?.data?.status === "READY") {
        clearInterval(poll);
        setReport(res.data);
        setRegenerating(false);
      }
    }, 4000);
  };

  return (
    <DashboardShell links={LINKS} activePath="/admin/sample-report">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-6">
        <h1 className="font-heading text-2xl font-bold text-slate-900" data-testid="admin-sample-report-heading">Sample Report</h1>
        <Button variant="outline" size="sm" onClick={regenerate} disabled={regenerating} data-testid="regenerate-sample-report-button">
          <RefreshCw className={`h-4 w-4 mr-2 ${regenerating ? "animate-spin" : ""}`} /> {regenerating ? "Regenerating…" : "Regenerate Sample"}
        </Button>
      </div>
      {loading && <p className="text-sm text-slate-400" data-testid="sample-report-loading">Loading sample report…</p>}
      {!loading && !report && <p className="text-sm text-slate-400" data-testid="sample-report-empty">No sample report generated yet.</p>}
      {!loading && report && <ReportView report={report} isSample />}
    </DashboardShell>
  );
}
